import { useState } from "react";

import { Cursor } from "@/components/ui/icons";
import { Button } from "@/components/ui/button";

const CURSOR_PROMPT_LINK = "https://cursor.com/link/prompt";

const getCursorPromptUrl = (prompt: string) => {
  const url = new URL(CURSOR_PROMPT_LINK);
  url.searchParams.set("text", prompt);
  return url.toString();
};

interface AgentPromptBannerProps {
  prompt: string;
}

export const AgentPromptBanner = ({ prompt }: AgentPromptBannerProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const cursorUrl = getCursorPromptUrl(prompt);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(prompt);
    setIsCopied(true);
    window.setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div className="flex flex-col gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
      <p className="min-w-0 text-sm text-gray-700">
        Use this prebuilt prompt to get started faster.
      </p>
      <div className="flex shrink-0 flex-wrap items-center gap-2">
        <Button asChild variant="secondary" size="sm" className="gap-2">
          <a href={cursorUrl} target="_blank" rel="noopener noreferrer">
            <Cursor className="h-4 w-auto" aria-hidden />
            Open in Cursor
          </a>
        </Button>
        <Button type="button" size="sm" onClick={handleCopy}>
          {isCopied ? "Copied!" : "Copy Prompt"}
        </Button>
      </div>
    </div>
  );
};
